/** Save on Chain targets Ethereum mainnet. WalletConnect must offer that chain. */
export const WALLETCONNECT_CHAIN_IDS = [1] as const

/**
 * Web3Modal v1 does `new Package(options)` then `enable()`.
 * WalletConnect v2's EthereumProvider is created with `init()`, so this class
 * is the drop-in the modal can construct.
 */
export default class WalletConnectV2Provider {
	private opts: { infuraId?: string; rpc?: Record<number, string>; qrcode?: boolean }
	private inner: any

	constructor(opts: { infuraId?: string; rpc?: Record<number, string>; qrcode?: boolean } = {}) {
		this.opts = opts
	}

	async enable() {
		const projectId = process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID
		if (!projectId) {
			throw new Error(
				"WalletConnect is not configured. Set NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID from cloud.reown.com.",
			)
		}

		const { EthereumProvider } = await import("@walletconnect/ethereum-provider")
		const infuraId = this.opts.infuraId
		const rpcMap =
			this.opts.rpc ||
			(infuraId ? { "1": `https://mainnet.infura.io/v3/${infuraId}` } : undefined)

		this.inner = await EthereumProvider.init({
			projectId,
			chains: [...WALLETCONNECT_CHAIN_IDS],
			showQrModal: this.opts.qrcode !== false,
			rpcMap,
			metadata: {
				name: "Hape",
				description: "Hape Fashion Index",
				url: typeof window !== "undefined" ? window.location.origin : "https://index.hape.io",
				icons: ["https://index.hape.io/favicon.ico"],
			},
		})

		this.request = (args: { method: string; params?: unknown[] }) => this.inner.request(args)
		this.on = (event: string, listener: (...args: unknown[]) => void) => this.inner.on(event, listener)
		this.removeListener = (event: string, listener: (...args: unknown[]) => void) =>
			this.inner.removeListener(event, listener)
		this.disconnect = () => this.inner.disconnect()

		return this.inner.enable()
	}

	request!: (args: { method: string; params?: unknown[] }) => Promise<unknown>
	on!: (event: string, listener: (...args: unknown[]) => void) => void
	removeListener!: (event: string, listener: (...args: unknown[]) => void) => void
	disconnect!: () => Promise<void>
}
